<!--analytics start-->
<div id="chart-overflow" *ngIf="show"></div>
<div class="analytics" *ngIf="show">
  <div id="heading-one">{{ 'ANALYTICS.LINE_ONE' | translate }}</div>
  <div id="heading-two"><span>"</span>{{ 'ANALYTICS.LINE_TWO' | translate }}<span>"</span></div>
  <div id="heading-three">{{ 'ANALYTICS.LINE_THREE' | translate }}</div>
  <div id="heading-four">{{ 'ANALYTICS.LINE_FOUR' | translate }}</div>
  <div id="chart-one">
    <div id="chart-div-one">
      <div id="chart-title">{{ 'ANALYTICS.VIDEO_WATCHED' | translate }}</div>
      <!-- <div class="chart-cover"></div> -->
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
        [callbackFunction]="chartCallback" [(update)]="updateFlag" [oneToOne]="oneToOneFlag"
        [runOutsideAngular]="runOutsideAngularFlag"></highcharts-chart>
    </div>
  </div>
  <!-- <div id="video-heading">
    <span></span>
    {{ 'ANALYTICS.VIDEO' | translate }}</div> -->
  <div id="chart-two">
    <div id="chart-div-two">
      <highcharts-chart [Highcharts]="fifteenDayChart" [constructorType]="fifteenDayChartConstructor"
        [options]="fifteenDayChartOptions" [callbackFunction]="fifteenDayChartCallback"
        [(update)]="fifteenDayUpdateFlag" [oneToOne]="fifteenDayOneToOneFlag"
        [runOutsideAngular]="fifteenDayRunOutsideAngularFlag"></highcharts-chart>
    </div>
  </div>
  <div id="heading-five">{{ 'ANALYTICS.LINE_FIVE' | translate }}</div>
  <div id="chart-footer">
    <div id="do-not-show" (click)="doNotShow()">{{ 'ANALYTICS.DO_NOT_SHOW_AGAIN' | translate }}</div>
    <div id="analytics-close" (click)="closeAnalytics()">{{ 'ANALYTICS.CLOSE' | translate }}</div>
  </div>
</div>
<!--end of the analytics-->